/*
 * @Author: libo 
 * @Date: 2020-11-13 17:26:14 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-07-04 17:34:20
 */

<!--批量导入界面-->
<template>
    <a-modal
        :title="title"
        :width="800"
        :visible="visible"
        :confirmLoading="confirmLoading"
        :okButtonProps="{ props: {disabled: disableSubmit} }"
        :maskClosable="maskClosable"
        @ok="handleOk"
        @cancel="handleCancel"
        :cancelText="$t('关闭')">
        
        <a-spin :spinning="confirmLoading">
        <a-form-model ref="formModal" :model="model" :rules="rules" :colon="false" layout="vertical">
            <div>
                <a-row :gutter="24">
                    <a-col :span="24">
                        <a-form-model-item :label="$t('上传文件')">
                            <a-upload name="file" 
                                :multiple="false" 
                                accept=".xls,.xlsx"
                                :fileList="fileList" 
                                :headers="tokenHeader"
                                :beforeUpload="beforeUpload"
                                :remove="handleRemove"
                                > 
                                <a-button>
                                    <a-icon type="upload" />
                                    {{ $t('选择导入文件') }}
                                </a-button>
                            </a-upload>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="24">
                    <a-col :xl="8" :lg="7" :md="8" :sm="24">
                        <a-form-model-item :label="$t('任务名称')" prop="taskName">
                            <a-input :placeholder="$t('请输入任务名称')" v-model="model.taskName"></a-input>
                        </a-form-model-item>
                    </a-col>
                    <a-col :xl="8" :lg="7" :md="8" :sm="24">
                        <a-form-model-item :label="$t('任务类型')" prop="taskType">
                            <a-select :placeholder="$t('请选择')" v-model="model.taskType">
                                <a-select-option :value="1">{{ $t('批量报装') }}</a-select-option>
                                <a-select-option :value="2">{{ $t('批量建档') }}</a-select-option>
                                <a-select-option :value="3">{{ $t('批量激活') }}</a-select-option>
                                <a-select-option :value="4">{{ $t('批量删除') }}</a-select-option>
                                <a-select-option :value="6">{{ $t('批量更新经纬度') }}</a-select-option>
                                <!--<a-select-option :value="7">{{ $t('收费对账') }}</a-select-option>-->
                                <a-select-option :value="9">{{ $t('批量更新册号') }}</a-select-option>
                                <a-select-option :value="10">{{ $t('批量一键激活') }}</a-select-option>
                                <a-select-option :value="11">{{ $t('批量更新出厂日期') }}</a-select-option>
                                <a-select-option :value="12">{{ $t('微信对账') }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :xl="24" :lg="24" :md="24" :sm="24">
                        <a-form-model-item :label="$t('描述')" prop="remark">
                            <a-textarea v-model="model.remark" rows="3" :placeholder="$t('请输入备注')" style="width:100%"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </div>
        </a-form-model>
        </a-spin>
    </a-modal>
</template>

<script>
    import { postAction } from '@/api/manage'
    import { ACCESS_TOKEN } from "@/store/mutation-types"
    import Vue from 'vue'

    export default {
        name: 'softwareModal',
        props: {
            //表单禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        data () {
            return {
                title:"",
                visible: false,
                disableSubmit:false,
                tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
                maskClosable:false,
                model: {},
                confirmLoading: false,
                url: {
                    importExcelUrl: "jeecg-charge/meter/meterBatchTaskRecord/batchAddMeterByExcel",//导入
                },
                fileList: []
            }
        },
        computed: {
            importExcelUrl: function(){
                return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
            },
            // i18n：校验消息使用 computed 以响应语言切换
            rules(){
                return {
                    taskName:[{ required: true, message: this.$t('请输入任务名称')}], //订单编号
                    taskType:[{ required: true, message: this.$t('请选择任务类型')}], //表类型
                }
            },
        },
        created () {
        
        },
        methods: {
            handleOk() {
                console.log("点击提交")
                const that = this;
                // 触发表单验证
                if(this.fileList.length==0) {
                    this.$message.error(this.$t("请先选择上传文件"))
                    return
                }
                this.$refs.formModal.validate(valid => {
                    if(valid) {
                        this.handleUpload()
                    }else{
                        return false
                    }
                })
            },
            handleUpload() {
                this.confirmLoading = true
                const { fileList } = this;
                let formData = new FormData();
                //formData = Object.assign(formData,this.model)
                formData.append('taskName', this.model.taskName);
                formData.append('taskType', this.model.taskType);
                if(this.model.remark) {
                    formData.append('remark', this.model.remark);
                }
                
                fileList.forEach((file) => {
                    formData.append('file', file);
                });
                postAction(this.importExcelUrl, formData).then((res) => {
                    this.confirmLoading = false
                    if(res.success){
                        this.$message.success(res.message || this.$t("创建成功"))
                        this.$emit('ok')
                        this.close()
                    }else{
                        this.$message.warning(res.message)
                    }
                })
            },
            handleRemove(file) {
                const index = this.fileList.indexOf(file);
                const newFileList = this.fileList.slice();
                newFileList.splice(index, 1);
                this.fileList = newFileList;
                },
            beforeUpload(file) {
                // 只支持Excel,
                let fileName = file.name;
                let fileType = fileName.substring(fileName.lastIndexOf("."),fileName.length);
                console.log(fileType)
                if(fileType!='.xls' && fileType!='.xlsx') {
                    this.$message.error(this.$t("只支持.xls,.xlsx格式文件！"))
                    return false;
                }else{
                    this.fileList = [file];
                    return false;
                }
            },
            add() {
                this.edit({});
            },
            edit (record) {
                this.visible = true;
                this.title = this.$t('操作');
                this.model = Object.assign(this.model,record)
            },
            close () {
                this.$emit('close');
                this.$refs.formModal.resetFields()
                this.model = this.$options.data.call(this).model
                this.fileList = this.$options.data.call(this).fileList
                this.disableSubmit = false;
                this.visible = false;
            },

            handleCancel () {
                this.close();
            }
        }
    }
</script>
<style scoped>
    .ant-form-item >>> .ant-select{
    width: 100%;
    }
    .span {
    margin: 8px;
    }
    .detail-list >>> .content{
    line-height: normal;
    }
</style>